import api from "@axios";
import * as ep from "../../endpoints";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { hasError } from "@/utils/utils";
export default {
  namespaced: true,
  state: {
    general_info: {},
    loading: false,
    editing: false,
  },
  getters: {
    general_info(state) {
      return state.general_info;
    },
    loading(state) {
      return state.loading;
    },
    editing(state) {
      return state.editing;
    },
  },
  mutations: {
    setGeneralInfo(state, payload) {
      state.general_info = payload;
    },
    setEditing(state, payload) {
      state.editing = payload;
    },
    setLoading(state, payload) {
      state.loading = payload;
    },
  },

  actions: {
    async getGenaralInfo({ commit }) {
      commit("setLoading", true);
      try {
        const data = await api.get(ep.generalInfo).then((res) => res.data.data);
        commit("setGeneralInfo", data);
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حصل خطأ أثناء جلب المعلومات",
            icon: "AlertIcon",
            variant: "danger",
          },
        });
      } finally {
        commit("setLoading", false);
      }
    },
    async editGeneralInfo({ commit, state, dispatch }, form) {
      commit("setEditing", true);
      try {
        const res = await api.put(
          ep.GENERAL_INFO_BY_ID(state.general_info.id),
          form
        );
        if (hasError(res.status)) throw "server error";
        else {
          this._vm.$toast({
            component: ToastificationContent,
            props: {
              title: "تم تعديل المعلومات بنجاح",
              icon: "CheckSquareIcon",
              variant: "success",
            },
          });
          dispatch("getGenaralInfo");
        }
      } catch (err) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حصل خطأ أثناء تعديل المعلومات",
            icon: "AlertIcon",
            variant: "danger",
          },
        });
      } finally {
        commit("setEditing", false);
      }
    },
  },
};
